export interface NewsItem {
    body: string
    id: number
    locationId: string
    media?: NewsMedia
    officeId?: number
    originalSource: string
    published: string
    provider: string
    publisherLogoUrl?: string
    publisherName?: string
    publisherUrl?: string
    textParts: string[]
    title: string
    url: string
    type?: NewsType
    locationName: string
    position?: number
}

export enum NewsType {
    POLICE = 'POLICE',
    FIRE = 'FIRE',
    RSS = 'RSS',
}

export interface NewsError {
    error: string
}

export interface NewsImage {
    caption: string
    id: number
    name: string
    type: string
    url: string
}

export interface NewsMedia {
    image?: NewsImage[]
}

export interface NewsResponse {
    content: NewsItem[]
    first: boolean
    last: boolean
    location?: string
    number: number
    radiusExpansion?: string
    radiusExpansionBy?: RadiusExpansionType
    size: number
    totalElements: number
    totalPages: number
}

export interface PoliceRssNewsResponse {
    policeNews: NewsItem[]
    rssNews: NewsItem[]
}
export enum RadiusExpansionType {
    RADIUS_IN_METERS = 'RADIUS_IN_METERS',
    FEDERAL_STATE = 'FEDERAL_STATE',
}
